import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-video',
  imports: [CommonModule, CarouselModule],
  templateUrl: './video.component.html',
})
export class VideoComponent implements OnChanges {
  // @Input({ required: true }) content!: ProductDesignTemplatePageContent;
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;

  items: ProductDesignTemplatePageModuleDataContent[] = [];

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }

  getSafeUrl(url: string | undefined): SafeResourceUrl {
    if (!url) {
      return '';
    }
  
    let embedUrl = url;
  
    try {
      const parsed = new URL(url);
  
      // ---------- YouTube ----------
      if (parsed.hostname.includes('youtube.com')) {
        // watch?v=VIDEO_ID
        if (parsed.pathname === '/watch') {
          const videoId = parsed.searchParams.get('v');
          if (videoId) embedUrl = `https://www.youtube.com/embed/${videoId}`;
        }
        // shorts/VIDEO_ID
        else if (parsed.pathname.startsWith('/shorts/')) {
          const videoId = parsed.pathname.split('/')[2];
          if (videoId) embedUrl = `https://www.youtube.com/embed/${videoId}`;
        }
        // playlist
        else if (parsed.pathname === '/playlist') {
          const listId = parsed.searchParams.get('list');
          if (listId) embedUrl = `https://www.youtube.com/embed/videoseries?list=${listId}`;
        }
      }
  
      // youtu.be/VIDEO_ID
      else if (parsed.hostname === 'youtu.be') {
        const videoId = parsed.pathname.slice(1);
        if (videoId) embedUrl = `https://www.youtube.com/embed/${videoId}`;
      }
  
      // ---------- Vimeo ----------
      else if (parsed.hostname.includes('vimeo.com')) {
        // vimeo.com/VIDEO_ID
        const videoId = parsed.pathname.split('/')[1];
        if (videoId) embedUrl = `https://player.vimeo.com/video/${videoId}`;
      }
    } catch {
      return '';
    }
  
    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

}
